import { Component } from '~preact';
import PropTypes from "prop-types";
import { Jiffy, RefresherV2 } from "@green24/npm-javascript-utils";
import { ValueUpdateListeners } from "../class/ValueUpdateListeners";

class HeartbeatRequester extends Component {
	/** @type RefresherV2 **/
	_refresher;

	/** @type ValueUpdateListeners **/
	_valueUpdateListeners;
	constructor(props) {
		super();

		this._valueUpdateListeners = new ValueUpdateListeners(this);

		if(props.shouldRefresh) {
			this._setupRefresher(props);
		}
	}

	componentDidMount() {
		this._valueUpdateListeners.add("props.refreshTime", () => {
			this._setupRefresher();
		});

		this._valueUpdateListeners.add("shouldRefresh", refresh => {
			if(refresh) {
				this._setupRefresher();
			}
			else {
				this._refresher?.stop();
			}
		});
	}

	componentDidUpdate(previousProps, previousState, snapshot) {
		this._valueUpdateListeners.componentDidUpdate(previousProps, previousState);
	}

	componentWillUnmount() {
		this._refresher?.stop();
	}

	render() {
		return null;
	}

	_setupRefresher({refreshTime, service} = this.props) {
		this._refresher = new RefresherV2(() => {
			service().finally(() => {
				this._refresher.trigger();
			});
		}, Jiffy.formatToMs(refreshTime));
	}

	static get propTypes() {
		return {
			refreshTime: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
			service: PropTypes.func,
			shouldRefresh: PropTypes.bool,
		}
	}

	static get defaultProps() {
		return {
			refreshTime: "30s",
			shouldRefresh: true,
		}
	}
}

export default HeartbeatRequester;
